import i18next from 'i18next';
import axios from 'axios';
import urlJoin from 'url-join';
import constants from './constants';
import getCurrentLocale from './current-locale';
import Configuration from '../modules/configuration';

function loadTranslations() {
  const locale = getCurrentLocale();
  const config = Configuration.get();
  
  return axios.get(urlJoin(config.getBasePath(), `/locale/${locale}.json`)).then((response) => {
    const { data } = response;
    const { DEFAULT_I18NEXT_NAMESPACE } = constants;

    i18next.addResourceBundle(locale, DEFAULT_I18NEXT_NAMESPACE, data, true, true);
    return i18next.changeLanguage(locale);
  });
}

export default loadTranslations;
